import React from 'react';
import { Link } from 'react-router-dom';

import { useDispatch, useSelector } from 'react-redux';
// import APIs
import LandingApi from './../api/admin/report/transport/Landing';

//import UIs
import { ErrorNotify } from '../ui/Toast';

// redux seters
import { RootState } from './../redux/reducers';
import { setIsLoading, setMetaData } from '../redux/reducers/page';

//import skeletons
import LandingCardSkeleton from '../ui/skeletons/LandingCard';

//import Enums
import transportStatuses from './../eNums/transportStatuses.enum';

// helpers **************************************************
import { jalaliDate } from './../helpers/convertDate.helper';
import { FromInt } from './../helpers/NumberTools';

const Landing = () => {
  const [isLoaded, setIsLoaded] = React.useState(false);
  const [fromDate, setFromDate] = React.useState(null);
  const [toDate, setTodDate] = React.useState(null);
  const [landingData, setLandingData] = React.useState([]);

  // redux
  const dispatch = useDispatch();
  const { auth } = useSelector((state: RootState) => state.adminAuth);
  const token = auth.token;

  // catch data **************************************************
  const catchData = async () => {
    const result = await LandingApi(token);
    if (result.status === 403) {
      ErrorNotify(JSON.parse(result.data).error);
      //dispatch(setLogOut(null));
      return;
    }

    if (result.status !== 200) {
      ErrorNotify(JSON.parse(result.data).error);
      return;
    }
    if (result.status === 200) {
      setFromDate(result.data.fromDate);
      setTodDate(result.data.toDate);
      const data = [
        {
          statusCode: 0,
          count: 0,
          statusText: 'در مسیر پارکینگ',
          link: '/transport/filter/status/0'

        },
        {
          statusCode: 1,
          count: 0,
          statusText: 'رسیده به پارکینگ',
          link: '/transport/filter/status/1'
        },
        {
          statusCode: 30,
          count: 0,
          statusText: 'داخل کارخانه',
          link: '/transport/filter/status/multi'
        },
        {
          statusCode: 8,
          count: 0,
          statusText: 'در انتظار پلمپ',
          link: '/transport/loading/polomp'
        },
        {
          statusCode: 9,
          count: 0,
          statusText: 'صدور بیجک',
          link: '/transport/filter/status/9'
        },
        {
          statusCode: -1,
          count: 0,
          statusText: 'مرجوع شده',
          link: '/transport/filter/status/-1'
        },
      ];
      for (const item of result.data.result) {
        if (![-10, 10].includes(item.status)) {
          if ([2, 3, 4, 5, 6, 7].includes(item.status)) {
            data[2].count += item.count;
          }
          if (item.status === 0) data[0].count += item.count;
          if (item.status === 1) data[1].count += item.count;
          if (item.status === 8) data[3].count += item.count;
          if (item.status === 9) data[4].count += item.count;
          if (item.status === -1) data[5].count += item.count;
        }
      }
      setLandingData(data);
      setIsLoaded(true);
      return;
    }
  };

  React.useEffect(() => {
    dispatch(setIsLoading(false));
    dispatch(
      setMetaData({
        title: 'weighbridge : صفحه اصلی',
        description: 'weighbridge:  صفحه اصلی',
      }),
    );
    catchData();
  }, []);

  return (
    <>
      <b></b>
      <div className="col-12 col-md-12  col-lg-10 col-xl-8  justify-content-center mt-4">
        {isLoaded ? (
          <div className="row  mb-5">
            {/* <div className="col-12 col-md-10 p-2 mb-2">
              <p>
                {' '}
                {`خلاصه وضعیت از تاریخ   ${FromInt(
                  jalaliDate(fromDate),
                )} تا    ${FromInt(jalaliDate(toDate))} `}
              </p>
            </div> */}
            {landingData.map((item, index) => {
              return (
                //
                <div className="col-6 col-md-4" key={index}>
                  <Link to={item.link} className="panel-link">
                    <div className="row p-2" style={{ minHeight: '200px' }}>
                      <div className="col-12 p-3 mt-4 bg-secondary">
                        <h2 className="text-white">{item.statusText}</h2>
                        <br></br>
                        <br></br>
                        <br></br>
                        <h2 className="text-white text-left">
                          {FromInt(item.count)} عدد
                        </h2>
                      </div>
                    </div>
                    </Link>
                  </div>
                
              );
            })}
          </div>
        ) : (
          <LandingCardSkeleton />
        )}
      </div>
    </>
  );
};

export default Landing;
